// extracted by mini-css-extract-plugin
export var labelWrapper = "_fk-0";